import { cloneDeep } from 'lodash/fp';

export const CONSTRUCT_BRANDS = [
  {
    status: '',
    count: 2,
    display_name: '1986',
    value: '1986',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: '0 PT',
    value: '0 pt',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 13,
    display_name: '032C',
    value: '032c',
    data: {},
  },
  {
    status: '',
    count: 27,
    display_name: '1017 ALYX 9SM',
    value: '1017 alyx 9sm',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: '11 by Boris Bidjan Saberi',
    value: '11 by boris bidjan saberi',
    data: {
      year: '2013',
      location: 'Barcelona, ES',
    },
  },
  {
    status: '',
    count: 1,
    display_name: '361 Degrees',
    value: '361 degrees',
    data: {
      year: '2003',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: '5 Moncler',
    value: '5 moncler',
    data: {
      year: '1952',
      location: '',
    },
  },
  {
    status: '',
    count: 6,
    display_name: 'A-Cold-Wall*',
    value: 'a cold wall',
    data: {
      year: '2015',
      location: 'London, UK',
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Abshire-Raynor',
    value: 'abshire raynor',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 5,
    display_name: 'Acne',
    value: 'acne',
    data: {
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 42,
    display_name: 'Acne Studios',
    value: 'acne studios',
    data: {
      year: '1996',
      location: 'Stockholm, SE',
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Ader Error',
    value: 'ader error',
    data: {
      year: '2014',
      location: 'Seoul, KR',
    },
  },
  {
    status: '',
    count: 13583,
    display_name: 'adidas',
    value: 'adidas',
    data: {
      year: '1949',
      location: 'Herzogenaurach, DE',
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Advisory Board Crystals',
    value: 'advisory board crystals',
    data: {
      location: 'Los Angeles, US',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Afield Out',
    value: 'afield out',
    data: {
      location: 'Santa Ana, US',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 2,
    display_name: 'Agolde',
    value: 'agolde',
    data: {
      location: 'Los Angeles, US',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 3,
    display_name: 'Aimé Leon Dore',
    value: 'aime leon dore',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 4006,
    display_name: 'Air Jordan',
    value: 'air jordan',
    data: {
      year: '1984',
      location: 'Chicago, US',
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Airwalk',
    value: 'airwalk',
    data: {
      year: '1986',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Akai',
    value: 'akai',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Akila',
    value: 'akila',
    data: {
      location: '',
    },
  },
  {
    status: '',
    count: 2,
    display_name: 'Akira',
    value: 'akira',
    data: {
      year: '2002',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Aldo',
    value: 'aldo',
    data: {
      year: '1972',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Alejandro Ingelmo',
    value: 'alejandro ingelmo',
    data: {
      year: '2006',
      location: '',
    },
  },
  {
    status: '',
    count: 9,
    display_name: 'Alexander McQueen',
    value: 'alexander mcqueen',
    data: {
      year: '1992',
      location: 'London, UK',
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 2,
    display_name: 'Alexander Wang',
    value: 'alexander wang',
    data: {
      year: '2007',
      location: '',
    },
  },
  {
    status: '',
    count: 9,
    display_name: 'Alife',
    value: 'alife',
    data: {
      year: '1999',
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 13,
    display_name: 'Ambush',
    value: 'ambush',
    data: {
      year: '2008',
      location: 'Tokyo, JP',
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Ami',
    value: 'ami',
    data: {
      year: '2011',
      location: 'Paris, FR',
    },
  },
  {
    status: '',
    count: 16,
    display_name: 'Amiri',
    value: 'amiri',
    data: {
      year: '2014',
      location: 'Los Angeles, US',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'And 1',
    value: 'and 1',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'And Wander',
    value: 'and wander',
    data: {
      year: '2011',
      location: 'Tokyo, JP',
    },
  },
  {
    status: '',
    count: 6,
    display_name: 'AND1',
    value: 'and1',
    data: {
      year: '1993',
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 2,
    display_name: 'Andrej Urem',
    value: 'andrej urem',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Anta',
    value: 'anta',
    data: {
      year: '1990',
      location: '',
    },
  },
  {
    status: '',
    count: 3,
    display_name: 'A.P.C.',
    value: 'apc',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Aprix',
    value: 'aprix',
    data: {
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: "Arc'teryx",
    value: 'arcteryx',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 8,
    display_name: 'Aries',
    value: 'aries',
    data: {
      year: '2012',
      location: 'London, UK',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 2,
    display_name: 'Art',
    value: 'art',
    data: {
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Article Number',
    value: 'article number',
    data: {
      year: '2014',
      location: '',
    },
  },
  {
    status: '',
    count: 821,
    display_name: 'ASICS',
    value: 'asics',
    data: {
      year: '1977',
      location: 'Kobe, JP',
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 2,
    display_name: 'Ateliers Arthur',
    value: 'ateliers arthur',
    data: {
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Auditions',
    value: 'auditions',
    data: {
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Awake NY',
    value: 'awake ny',
    data: {
      year: '2012',
      location: 'New York, US',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Babylon LA',
    value: 'babylon la',
    data: {
      year: '2015',
      location: 'Los Angeles, US',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Bailey, Veum and Ryan',
    value: 'bailey veum and ryan',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 23,
    display_name: 'Balenciaga',
    value: 'balenciaga',
    data: {
      year: '1919',
      location: 'Paris, FR',
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Bally',
    value: 'bally',
    data: {
      year: '1851',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Balmain',
    value: 'balmain',
    data: {
      year: '1945',
      location: 'Paris, FR',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Bandai',
    value: 'bandai',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 2,
    display_name: 'Bao Bao Issey Miyake',
    value: 'bao bao issey miyake',
    data: {
      year: '1971',
      location: '',
    },
  },
  {
    status: '',
    count: 581,
    display_name: 'BAPE',
    value: 'bape',
    data: {
      year: '1993',
      location: 'Tokyo, JP',
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 4,
    display_name: 'Bape 2',
    value: 'bape 2',
    data: {
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Bartoletti LLC',
    value: 'bartoletti llc',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Barton-Kohler',
    value: 'barton kohler',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 69,
    display_name: 'Batman',
    value: 'batman',
    data: {
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Bayer, Heathcote and Von',
    value: 'bayer heathcote and von',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Beatty, Green and Considine',
    value: 'beatty green and considine',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Bechtelar, Sawayn and Bergstrom',
    value: 'bechtelar sawayn and bergstrom',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Bergnaum Inc',
    value: 'bergnaum inc',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Better™ Gift Shop',
    value: 'better gift shop',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 2,
    display_name: 'Bicycle',
    value: 'bicycle',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Big Baller Brand',
    value: 'big baller brand',
    data: {
      year: '2016',
      location: '',
    },
  },
  {
    status: '',
    count: 33,
    display_name: 'Billionaire Boys Club',
    value: 'billionaire boys club',
    data: {
      year: '2005',
      location: 'New York, US',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Binu Binu',
    value: 'binu binu',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 5,
    display_name: 'Birkenstock',
    value: 'birkenstock',
    data: {
      year: '1774',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Bode',
    value: 'bode',
    data: {
      location: 'NYC, US',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 6,
    display_name: 'Books',
    value: 'books',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Borer, Doyle and Hane',
    value: 'borer doyle and hane',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 3,
    display_name: 'Born x Raised',
    value: 'born x raised',
    data: {
      year: '2011',
      location: 'Los Angeles, US',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Boston Scally Co.',
    value: 'boston scally co',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 5,
    display_name: 'Bottega Veneta',
    value: 'bottega veneta',
    data: {
      year: '1966',
      location: 'Vicenza, IT',
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 8,
    display_name: 'Brain Dead',
    value: 'brain dead',
    data: {
      year: '2014',
      location: 'Los Angeles, US',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Brandblack',
    value: 'brandblack',
    data: {
      year: '2014',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Brekke, Gutmann and Tremblay',
    value: 'brekke gutmann and tremblay',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Bricks & Wood',
    value: 'bricks wood',
    data: {
      year: '2014',
      location: 'Los Angeles, US',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'British Knights',
    value: 'british knights',
    data: {
      year: '1983',
      location: '',
    },
  },
  {
    status: '',
    count: 48,
    display_name: 'Brooks',
    value: 'brooks',
    data: {
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Brown Inc',
    value: 'brown inc',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 2,
    display_name: 'Burberry',
    value: 'burberry',
    data: {
      year: '1856',
      location: 'London, UK',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Buscemi',
    value: 'buscemi',
    data: {
      year: '2013',
      location: '',
    },
  },
  {
    status: '',
    count: 9,
    display_name: 'C2H4',
    value: 'c2h4',
    data: {
      year: '2014',
      location: 'Los Angeles, US',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Cactus Jack by Travis Scott',
    value: 'cactus jack by travis scott',
    data: {
      year: '2017',
      location: 'US',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 2,
    display_name: 'Cactus Plant Flea Market',
    value: 'cactus plant flea market',
    data: {
      year: '2015',
      location: 'London, UK',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Calvin Klein',
    value: 'calvin klein',
    data: {
      year: '1968',
      location: 'New York, US',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Canal Cafeteria',
    value: 'canal cafeteria',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 20,
    display_name: 'Carhartt WIP',
    value: 'carhartt wip',
    data: {
      year: '1889',
      location: 'Detroit, US',
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Cariuma',
    value: 'cariuma',
    data: {
      year: '2018',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Carrots',
    value: 'carrots',
    data: {
      year: '2007',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Casa Magazines',
    value: 'casa magazines',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 15,
    display_name: 'Casablanca',
    value: 'casablanca',
    data: {
      year: '2018',
      location: 'Paris, FR',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Casbia',
    value: 'casbia',
    data: {
      year: '2009',
      location: 'Milan, IT',
    },
  },
  {
    status: '',
    count: 25,
    display_name: 'Cav Empt',
    value: 'cav empt',
    data: {
      year: '2011',
      location: 'Tokyo, JP',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Cecilie Bahnsen',
    value: 'cecilie bahnsen',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'CELINE',
    value: 'celine',
    data: {
      year: '1945',
      location: 'Paris, FR',
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Champion',
    value: 'champion',
    data: {
      year: '1919',
      location: 'New York, US',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Chanel',
    value: 'chanel',
    data: {
      year: '1910',
      location: 'Paris, FR',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Charles Jeffrey Loverboy',
    value: 'charles jeffrey loverboy',
    data: {
      location: 'London, UK',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Cherry LA',
    value: 'cherry la',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Children of the Discordance',
    value: 'children of the discordance',
    data: {
      year: '2011',
      location: 'Tokyo, JP',
    },
  },
  {
    status: '',
    count: 5,
    display_name: 'Chinatown Market',
    value: 'chinatown market',
    data: {
      year: '2016',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 2,
    display_name: 'Chloé',
    value: 'chloe',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 3,
    display_name: 'Christian Dior',
    value: 'christian dior',
    data: {
      year: '1946',
      location: 'Paris, FR',
    },
  },
  {
    status: '',
    count: 4,
    display_name: 'Christian Louboutin',
    value: 'christian louboutin',
    data: {
      year: '1991',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Christopher John Rogers',
    value: 'christopher john rogers',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 3,
    display_name: 'Chrome Hearts',
    value: 'chrome hearts',
    data: {
      year: '1988',
      location: 'Los Angeles, US',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Cipher',
    value: 'cipher',
    data: {
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Circa',
    value: 'circa',
    data: {
      year: '1999',
      location: '',
    },
  },
  {
    status: '',
    count: 258,
    display_name: 'CLAE',
    value: 'clae',
    data: {
      year: '2001',
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 2,
    display_name: 'Clarks',
    value: 'clarks',
    data: {
      year: '1825',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Clearweather',
    value: 'clearweather',
    data: {
      year: '1990',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'CLOT',
    value: 'clot',
    data: {
      year: '2003',
      location: 'Hong Kong',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Coach',
    value: 'coach',
    data: {
      year: '1941',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Cole Haan',
    value: 'cole haan',
    data: {
      year: '1928',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Collegium',
    value: 'collegium',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 2,
    display_name: 'Comme des Garçons',
    value: 'comme des garcons',
    data: {
      year: '1969',
      location: 'Paris, FR',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Comme des Garçons Homme Plus',
    value: 'comme des garcons homme plus',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 3,
    display_name: 'Comme des Garçons PLAY',
    value: 'comme des garcons play',
    data: {
      year: '2002',
      location: 'Paris, FR',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 23,
    display_name: 'Comme des Garçons SHIRT',
    value: 'comme des garcons shirt',
    data: {
      year: '2002',
      location: 'Paris, FR',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Comme des Garçons Wallet',
    value: 'comme des garcons wallet',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Common Projects',
    value: 'common projects',
    data: {
      year: '2004',
      location: '',
    },
  },
  {
    status: '',
    count: 2,
    display_name: 'Constructor Drip',
    value: 'constructor drip',
    data: {
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 1107,
    display_name: 'Converse',
    value: 'converse',
    data: {
      year: '1908',
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Coperni',
    value: 'coperni',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Courrèges',
    value: 'courreges',
    data: {
      location: 'Paris, FR',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 2,
    display_name: 'Craig Green',
    value: 'craig green',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 572,
    display_name: 'Creative Recreation',
    value: 'creative recreation',
    data: {
      year: '2002',
      location: 'Los Angeles, US',
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Crep Protect',
    value: 'crep protect',
    data: {
      year: '2012',
      location: 'London, UK',
    },
  },
  {
    status: '',
    count: 8,
    display_name: 'Crocs',
    value: 'crocs',
    data: {
      year: '2002',
      location: 'Colorado, US',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Crooks Group',
    value: 'crooks group',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'CU4TRO',
    value: 'cu4tro',
    data: {
      year: '2016',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Curry Brand',
    value: 'curry brand',
    data: {
      year: '2019',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Curves by Sean Brown',
    value: 'curves by sean brown',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Dada',
    value: 'dada',
    data: {
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Daily Paper',
    value: 'daily paper',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Damir Doma',
    value: 'damir doma',
    data: {
      year: '2006',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Danner',
    value: 'danner',
    data: {
      year: '1932',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Dare-Paucek',
    value: 'dare paucek',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 10,
    display_name: 'Dc',
    value: 'dc',
    data: {
      year: '1994',
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'DC Comics',
    value: 'dc comics',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 78,
    display_name: 'Diadora',
    value: 'diadora',
    data: {
      year: '1948',
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Diamond Supply Co.',
    value: 'diamond supply co',
    data: {
      year: '1998',
      location: 'Los Angeles, US',
    },
  },
  {
    status: '',
    count: 2,
    display_name: 'Diesel',
    value: 'diesel',
    data: {
      year: '1978',
      location: '',
    },
  },
  {
    status: '',
    count: 18,
    display_name: 'Dime',
    value: 'dime',
    data: {
      year: '2005',
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 8,
    display_name: 'Dior',
    value: 'dior',
    data: {
      year: '1946',
      location: 'Paris, FR',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Dior Homme',
    value: 'dior homme',
    data: {
      year: '1946',
      location: 'Paris, FR',
    },
  },
  {
    status: '',
    count: 2,
    display_name: 'Dolce & Gabbana',
    value: 'dolce gabbana',
    data: {
      year: '1985',
      location: 'Milan, IT',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Donnelly, Johnson and Effertz',
    value: 'donnelly johnson and effertz',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Double RL',
    value: 'double rl',
    data: {
      year: '1993',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Doublet',
    value: 'doublet',
    data: {
      location: 'Tokyo, JP',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 8,
    display_name: 'Dr. Martens',
    value: 'dr martens',
    data: {
      year: '1947',
      location: 'London, Uk',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Drew House',
    value: 'drew house',
    data: {
      year: '2019',
      location: 'US',
    },
  },
  {
    status: '',
    count: 2,
    display_name: 'Dries Van Noten',
    value: 'dries van noten',
    data: {
      year: '1986',
      location: 'Antwerp, BE',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'DuBuque Inc',
    value: 'dubuque inc',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'ECCO',
    value: 'ecco',
    data: {
      year: '1963',
      location: '',
    },
  },
  {
    status: '',
    count: 2,
    display_name: 'Eckhaus Latta',
    value: 'eckhaus latta',
    data: {
      year: '2011',
      location: 'Los Angeles, US',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Ellesse',
    value: 'ellesse',
    data: {
      year: '1959',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Emanuele Bicocchi',
    value: 'emanuele bicocchi',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Emerica',
    value: 'emerica',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Emmerich-Dooley',
    value: 'emmerich dooley',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Emporio Armani',
    value: 'emporio armani',
    data: {
      year: '1975',
      location: '',
    },
  },
  {
    status: '',
    count: 2,
    display_name: 'Enfants Riches Déprimés',
    value: 'enfants riches deprimes',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 4,
    display_name: 'Engineered Garments',
    value: 'engineered garments',
    data: {
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Eric Emanuel',
    value: 'eric emanuel',
    data: {
      year: '2003',
      location: '',
    },
  },
  {
    status: '',
    count: 15,
    display_name: 'ERL',
    value: 'erl',
    data: {
      year: '2018',
      location: 'Los Angeles, US',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Ernser-Koelpin',
    value: 'ernser koelpin',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 2,
    display_name: 'eS',
    value: 'es',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Etnies',
    value: 'etnies',
    data: {
      year: '1986',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Etonic',
    value: 'etonic',
    data: {
      year: '1876',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Etudes',
    value: 'etudes',
    data: {
      year: '2012',
      location: '',
    },
  },
  {
    status: '',
    count: 64,
    display_name: 'Ewing',
    value: 'ewing',
    data: {
      year: '2011',
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 14,
    display_name: 'Fear of God',
    value: 'fear of god',
    data: {
      year: '2013',
      location: 'Los Angeles, US',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 13,
    display_name: 'Fear of God Essentials',
    value: 'fear of god essentials',
    data: {
      year: '2013',
      location: 'Los Angeles, US',
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Feest, Simonis and Crona',
    value: 'feest simonis and crona',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 4,
    display_name: 'Fendi',
    value: 'fendi',
    data: {
      year: '1925',
      location: 'Rome, IT',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 142,
    display_name: 'Fila',
    value: 'fila',
    data: {
      year: '1911',
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Filling Pieces',
    value: 'filling pieces',
    data: {
      year: '2009',
      location: 'Amsterdam, NL',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Fisher-Gutmann',
    value: 'fisher gutmann',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 9,
    display_name: 'Flamingosis',
    value: 'flamingosis',
    data: {
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Flatlist',
    value: 'flatlist',
    data: {
      year: '2018',
      location: 'Copenhagen, DK',
    },
  },
  {
    status: '',
    count: 27,
    display_name: 'Flight Club',
    value: 'flight club',
    data: {
      year: '2005',
      location: 'New York, US',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Fly Boys Couture Club',
    value: 'fly boys couture club',
    data: {
      year: '2011',
      location: '',
    },
  },
  {
    status: '',
    count: 2,
    display_name: 'FOG essentials',
    value: 'fog essentials',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Foundation Footwear',
    value: 'foundation footwear',
    data: {
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Fracap',
    value: 'fracap',
    data: {
      year: '1848',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Franco Fortini',
    value: 'franco fortini',
    data: {
      year: '1994',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Frank Ocean',
    value: 'frank ocean',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Fred Perry',
    value: 'fred perry',
    data: {
      year: '1952',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Friesen Inc',
    value: 'friesen inc',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Frye',
    value: 'frye',
    data: {
      year: '1888',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'FTP',
    value: 'ftp',
    data: {
      year: '2010',
      location: '',
    },
  },
  {
    status: '',
    count: 18,
    display_name: 'Gallery Dept.',
    value: 'gallery dept',
    data: {
      year: '2016',
      location: 'Los Angeles, US',
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'GANNI',
    value: 'ganni',
    data: {
      year: '1999',
      location: 'Copenhagen, DK',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'GBX',
    value: 'gbx',
    data: {
      location: '',
    },
  },
  {
    status: '',
    count: 68,
    display_name: 'Generic Surplus',
    value: 'generic surplus',
    data: {
      year: '2008',
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Gentle Monster',
    value: 'gentle monster',
    data: {
      year: '2011',
      location: 'Seoul, SK',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Gerhold, Greenfelder and Fisher',
    value: 'gerhold greenfelder and fisher',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Giorgio Brutini',
    value: 'giorgio brutini',
    data: {
      year: '1969',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Giorgio Venturi',
    value: 'giorgio venturi',
    data: {
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Giuseppe Zanotti',
    value: 'giuseppe zanotti',
    data: {
      year: '1994',
      location: '',
    },
  },
  {
    status: '',
    count: 4,
    display_name: 'Givenchy',
    value: 'givenchy',
    data: {
      year: '1952',
      location: 'Paris, FR',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'GOAT',
    value: 'goat',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Golden Goose',
    value: 'golden goose',
    data: {
      year: '2013',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Goodwin and Sons',
    value: 'goodwin and sons',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Gorilla',
    value: 'gorilla',
    data: {
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Gosha Rubchinskiy',
    value: 'gosha rubchinskiy',
    data: {
      year: '2008',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Gottlieb, Grady and Stark',
    value: 'gottlieb grady and stark',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 86,
    display_name: 'Gourmet',
    value: 'gourmet',
    data: {
      year: '2006',
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 10,
    display_name: 'Gravis',
    value: 'gravis',
    data: {
      year: '1998',
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Greats',
    value: 'greats',
    data: {
      year: '2013',
      location: '',
    },
  },
  {
    status: '',
    count: 11,
    display_name: 'Greedy Genius',
    value: 'greedy genius',
    data: {
      year: '2005',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Greg Lauren',
    value: 'greg lauren',
    data: {
      year: '2011',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'GT Bicycles',
    value: 'gt bicycles',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 16,
    display_name: 'Gucci',
    value: 'gucci',
    data: {
      year: '1921',
      location: 'Florence, IT',
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Gundam',
    value: 'gundam',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'GUNPLA',
    value: 'gunpla',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Haider Ackermann',
    value: 'haider ackermann',
    data: {
      location: 'Antwerp, BE',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: "Halvorson, O'Conner and Dickinson",
    value: 'halvorson oconner and dickinson',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Haro Designs',
    value: 'haro designs',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Hatton Labs',
    value: 'hatton labs',
    data: {
      location: 'London, US',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Heidenreich, Kessler and Harvey',
    value: 'heidenreich kessler and harvey',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 25,
    display_name: 'Helmut Lang',
    value: 'helmut lang',
    data: {
      year: '1986',
      location: 'New York, US',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 59,
    display_name: 'Heron Preston',
    value: 'heron preston',
    data: {
      year: '2012',
      location: 'New York, US',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Hettinger Group',
    value: 'hettinger group',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Hi-Tec',
    value: 'hi tec',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 2,
    display_name: 'Hidden NY',
    value: 'hidden ny',
    data: {
      year: '2018',
      location: 'New York, US',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'H&M',
    value: 'hm',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Hodkiewicz-Lemke',
    value: 'hodkiewicz lemke',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 2,
    display_name: 'Hoka',
    value: 'hoka',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Homme Plissé Issey Miyake',
    value: 'homme plisse issey miyake',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 3,
    display_name: 'Honor The Gift',
    value: 'honor the gift',
    data: {
      year: '2017',
      location: 'Los Angeles, US',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 2,
    display_name: 'Hood By Air',
    value: 'hood by air',
    data: {
      year: '2006',
      location: 'New York, US',
    },
  },
  {
    status: '',
    count: 6,
    display_name: 'Hot Topic x Forever 21 x Hello Kitty x Urban Outfitters',
    value: 'hot topic x forever 21 x hello kitty x urban outfitters',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'HUF',
    value: 'huf',
    data: {
      year: '2002',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Hugo Boss',
    value: 'hugo boss',
    data: {
      year: '1924',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Hummel Hive',
    value: 'hummel hive',
    data: {
      year: '1923',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Hunter',
    value: 'hunter',
    data: {
      year: '1856',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Hyatt-Tillman',
    value: 'hyatt tillman',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Hyein Seo',
    value: 'hyein seo',
    data: {
      location: 'Seoul, KR',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Ian Charms',
    value: 'ian charms',
    data: {
      location: 'Los Angeles, US',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 2,
    display_name: 'Icecream',
    value: 'icecream',
    data: {
      year: '2004',
      location: 'New York, US',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'IDEA',
    value: 'idea',
    data: {
      location: '',
    },
  },
  {
    status: '',
    count: 7,
    display_name: 'Iise',
    value: 'iise',
    data: {
      year: '2013',
      location: 'Seoul, SK',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Image Comics',
    value: 'image comics',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Isabel Marant',
    value: 'isabel marant',
    data: {
      year: '1995',
      location: 'Paris, FRR',
    },
  },
  {
    status: '',
    count: 8,
    display_name: 'Issey Miyake',
    value: 'issey miyake',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 6,
    display_name: 'Jacquemus',
    value: 'jacquemus',
    data: {
      year: '2009',
      location: 'Paris, FR',
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Jason Markk',
    value: 'jason markk',
    data: {
      year: '2007',
      location: 'Los Angeles, US',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Jb',
    value: 'jb',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 2,
    display_name: 'Jean Paul Gaultier',
    value: 'jean paul gaultier',
    data: {
      year: '1976',
      location: 'Paris, FR',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Jil Sander',
    value: 'jil sander',
    data: {
      year: '1968',
      location: 'Hamburg, DE',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Jimmy Choo',
    value: 'jimmy choo',
    data: {
      year: '1996',
      location: '',
    },
  },
  {
    status: '',
    count: 77,
    display_name: 'John Elliott',
    value: 'john elliott',
    data: {
      year: '2012',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'John Geiger',
    value: 'john geiger',
    data: {
      year: '2017',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Johnson and Sons',
    value: 'johnson and sons',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Joma',
    value: 'joma',
    data: {
      year: '1965',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Jones Inc',
    value: 'jones inc',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Juicy',
    value: 'juicy',
    data: {
      year: '1997',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Junya Watanabe',
    value: 'junya watanabe',
    data: {
      year: '1992',
      location: 'Paris, FR',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Junya Watanabe MAN',
    value: 'junya watanabe man',
    data: {
      year: '1992',
      location: 'Paris, FR',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Justine Clenquet',
    value: 'justine clenquet',
    data: {
      location: 'Lille, FR',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Juun J',
    value: 'juun j',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'JW Anderson',
    value: 'jw anderson',
    data: {
      year: '2007',
      location: 'London, UK',
    },
  },
  {
    status: '',
    count: 11,
    display_name: 'K Swiss',
    value: 'k swiss',
    data: {
      year: '1966',
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'K1X',
    value: 'k1x',
    data: {
      year: '2014',
      location: '',
    },
  },
  {
    status: '',
    count: 2,
    display_name: 'KangaROOS',
    value: 'kangaroos',
    data: {
      year: '1979',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Kanye West',
    value: 'kanye west',
    data: {
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Kappa',
    value: 'kappa',
    data: {
      year: '1916',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'KARA',
    value: 'kara',
    data: {
      year: '2012',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Karhu',
    value: 'karhu',
    data: {
      year: '1916',
      location: 'Helsinki, FI',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Kartell',
    value: 'kartell',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Kate Spade New York',
    value: 'kate spade new york',
    data: {
      year: '1993',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'KAWS',
    value: 'kaws',
    data: {
      location: 'Brooklyn, NY',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Keebler, Heller and Will',
    value: 'keebler heller and will',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Keep',
    value: 'keep',
    data: {
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Keiser Clark',
    value: 'keiser clark',
    data: {
      year: '2017',
      location: 'Los Angeles, US',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Kenzo',
    value: 'kenzo',
    data: {
      year: '1970',
      location: 'Paris, FR',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Kids of Immigrants',
    value: 'kids of immigrants',
    data: {
      location: 'Los Angeles, US',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'KidSuper',
    value: 'kidsuper',
    data: {
      year: '2011',
      location: 'New York, US',
    },
  },
  {
    status: '',
    count: 25,
    display_name: 'Kith',
    value: 'kith',
    data: {
      year: '2011',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Know Wave',
    value: 'know wave',
    data: {
      year: '2012',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Kohler Inc',
    value: 'kohler inc',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Kozey Inc',
    value: 'kozey inc',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'KR3W',
    value: 'kr3w',
    data: {
      year: '2002',
      location: '',
    },
  },
  {
    status: '',
    count: 3,
    display_name: 'Ksubi',
    value: 'ksubi',
    data: {
      location: 'Sydney, AU',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Kuhlman-Bartoletti',
    value: 'kuhlman bartoletti',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Kyosho',
    value: 'kyosho',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'LA Gear',
    value: 'la gear',
    data: {
      year: '1983',
      location: 'Los Angeles, US',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 84,
    display_name: 'Lacoste',
    value: 'lacoste',
    data: {
      year: '1933',
      location: 'Paris, FR',
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Lakai',
    value: 'lakai',
    data: {
      year: '1999',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Lamborghini',
    value: 'lamborghini',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Lanvin',
    value: 'lanvin',
    data: {
      location: 'Paris, FRR',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Le Coq Sportif',
    value: 'le coq sportif',
    data: {
      year: '1882',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Leffler, Kuphal and King',
    value: 'leffler kuphal and king',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'LEGO',
    value: 'lego',
    data: {
      location: 'Billund, DK',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Lemaire',
    value: 'lemaire',
    data: {
      year: '1990',
      location: 'Paris, FR',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Les Tien',
    value: 'les tien',
    data: {
      year: '2018',
      location: 'Los Angeles, US',
    },
  },
  {
    status: '',
    count: 1,
    display_name: "Levi's",
    value: 'levis',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Li-Ning',
    value: 'li ning',
    data: {
      year: '1989',
      location: 'Beijing, CN',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 2,
    display_name: 'Liberaiders',
    value: 'liberaiders',
    data: {
      year: '2017',
      location: 'Tokyo, JP',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Lift Aviation',
    value: 'lift aviation',
    data: {
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Little Africa',
    value: 'little africa',
    data: {
      year: '2020',
      location: 'Los Angeles, US',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'L.L. Bean',
    value: 'll bean',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 5,
    display_name: 'Loewe',
    value: 'loewe',
    data: {
      year: '1846',
      location: 'Madrid, ES',
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 13,
    display_name: 'Louis Vuitton',
    value: 'louis vuitton',
    data: {
      year: '1854',
      location: 'Paris, FR',
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Lubowitz Inc',
    value: 'lubowitz inc',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Lubowitz-Mann',
    value: 'lubowitz mann',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Lugz',
    value: 'lugz',
    data: {
      year: '1993',
      location: '',
    },
  },
  {
    status: '',
    count: 3,
    display_name: 'Mad Foot',
    value: 'mad foot',
    data: {
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Madeline Stuart',
    value: 'madeline stuart',
    data: {
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Magda Butrym',
    value: 'magda butrym',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Maison Kitsuné',
    value: 'maison kitsune',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 41,
    display_name: 'Maison Margiela',
    value: 'maison margiela',
    data: {
      year: '1988',
      location: 'Paris, FR',
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 2,
    display_name: 'Maison Mihara Yasuhiro',
    value: 'maison mihara yasuhiro',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 2,
    display_name: 'Marcelo Burlon',
    value: 'marcelo burlon',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 7,
    display_name: 'Marine Serre',
    value: 'marine serre',
    data: {
      year: '2018',
      location: 'Paris, FR',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Mark McNairy',
    value: 'mark mcnairy',
    data: {
      year: '2006',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Market',
    value: 'market',
    data: {
      location: 'Los Angeles, US',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 14,
    display_name: 'Marni',
    value: 'marni',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: "Marques'Almeida",
    value: 'marquesalmeida',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Marshall Columbia',
    value: 'marshall columbia',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 4,
    display_name: 'Martine Ali',
    value: 'martine ali',
    data: {
      location: 'Brooklyn, NY',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 2,
    display_name: 'Martine Rose',
    value: 'martine rose',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Marvel Comics',
    value: 'marvel comics',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Mastermind',
    value: 'mastermind',
    data: {
      year: '1997',
      location: 'Tokyo, JP',
    },
  },
  {
    status: '',
    count: 4,
    display_name: 'Mastermind World',
    value: 'mastermind world',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'McClure-Johns',
    value: 'mcclure johns',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'McLaughlin-Fisher',
    value: 'mclaughlin fisher',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'McLaughlin LLC',
    value: 'mclaughlin llc',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'MCM',
    value: 'mcm',
    data: {
      year: '1976',
      location: '',
    },
  },
  {
    status: '',
    count: 75,
    display_name: 'MCQ',
    value: 'mcq',
    data: {
      year: '1992',
      location: 'London, UK',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'MediCom Toy',
    value: 'medicom toy',
    data: {
      location: 'Tokyo, JP',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Memor Studios',
    value: 'memor studios',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Mercer Amsterdam',
    value: 'mercer amsterdam',
    data: {
      year: '2013',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Merrell',
    value: 'merrell',
    data: {
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'MF Doom',
    value: 'mf doom',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Michael Antonio',
    value: 'michael antonio',
    data: {
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Midnight Studios',
    value: 'midnight studios',
    data: {
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Mighty Jaxx',
    value: 'mighty jaxx',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Miller-Wisoky',
    value: 'miller wisoky',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'MISBHV',
    value: 'misbhv',
    data: {
      year: '2014',
      location: 'Warsaw, PL',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Miu Miu',
    value: 'miu miu',
    data: {
      location: 'Milan, IT',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Mizuno',
    value: 'mizuno',
    data: {
      year: '1906',
      location: 'Osaka, JP',
    },
  },
  {
    status: '',
    count: 6,
    display_name: 'MM6 Maison Margiela',
    value: 'mm6 maison margiela',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Mohr-Schulist',
    value: 'mohr schulist',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Moncler',
    value: 'moncler',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Moncler Gamme Bleu',
    value: 'moncler gamme bleu',
    data: {
      year: '1952',
      location: 'Monestier-de-Clermont, FR',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Moncler Gamme Rogue',
    value: 'moncler gamme rogue',
    data: {
      year: '1952',
      location: 'Monestier-de-Clermont, FR',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Moncler Genius',
    value: 'moncler genius',
    data: {
      year: '1952',
      location: 'Monestier-de-Clermont, FR',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Moncler Grenoble',
    value: 'moncler grenoble',
    data: {
      year: '1952',
      location: 'Monestier-de-Clermont, FR',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Mosciski-Rutherford',
    value: 'mosciski rutherford',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Mossimo',
    value: 'mossimo',
    data: {
      year: '1986',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Mountain Gear',
    value: 'mountain gear',
    data: {
      year: '1983',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Movies',
    value: 'movies',
    data: {
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Mr. Saturday',
    value: 'mr saturday',
    data: {
      year: '2019',
      location: 'Toronto, CA',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Mugler',
    value: 'mugler',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Murray, Turner and Swaniawski',
    value: 'murray turner and swaniawski',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 2,
    display_name: 'Museum of Peace & Quiet',
    value: 'museum of peace quiet',
    data: {
      location: 'Los Angeles, US',
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 7,
    display_name: 'Music',
    value: 'music',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Mykita',
    value: 'mykita',
    data: {
      location: 'Berlin, DE',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Nahmias',
    value: 'nahmias',
    data: {
      year: '2018',
      location: 'Los Angeles, US',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'nanamica',
    value: 'nanamica',
    data: {
      year: '2003',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Native',
    value: 'native',
    data: {
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Nautica',
    value: 'nautica',
    data: {
      year: '1983',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Needles',
    value: 'needles',
    data: {
      year: '1997',
      location: 'Tokyo, Japan',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 35,
    display_name: 'Neighborhood',
    value: 'neighborhood',
    data: {
      year: '1994',
      location: 'Tokyo, Japan',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1036,
    display_name: 'New Balance',
    value: 'new balance',
    data: {
      year: '1906',
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 2,
    display_name: 'new brand ',
    value: 'new brand',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'New Republic',
    value: 'new republic',
    data: {
      location: '',
    },
  },
  {
    status: '',
    count: 2,
    display_name: 'N.Hoolywood',
    value: 'nhoolywood',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Nicolas Andreas Taralis',
    value: 'nicolas andreas taralis',
    data: {
      year: '2003',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'NIGOLD by UNITED ARROWS',
    value: 'nigold by united arrows',
    data: {
      location: '',
    },
  },
  {
    status: '',
    count: 16351,
    display_name: 'Nike',
    value: 'nike',
    data: {
      year: '1964',
      location: 'Beaverton, US',
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'NOAH',
    value: 'noah',
    data: {
      year: '2015',
      location: 'New York, US',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Nolan and Sons',
    value: 'nolan and sons',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Noon Goons',
    value: 'noon goons',
    data: {
      year: '2016',
      location: 'Los Angeles, US',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Norse Projects',
    value: 'norse projects',
    data: {
      year: '2004',
      location: 'Copenhagen, DK',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Nowhere',
    value: 'nowhere',
    data: {
      year: '1993',
      location: 'Tokyo, JP',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Number Nine',
    value: 'number nine',
    data: {
      year: '1997',
      location: 'Tokyo, JP',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'OAMC',
    value: 'oamc',
    data: {
      year: '2013',
      location: 'Paris, Fr',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Oberbrunner Inc',
    value: 'oberbrunner inc',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Oberbrunner, Ondricka and Vandervort',
    value: 'oberbrunner ondricka and vandervort',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 189,
    display_name: 'Off-White',
    value: 'off white',
    data: {
      year: '2012',
      location: 'Milan, IT',
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Okuneva LLC',
    value: 'okuneva llc',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Olympics',
    value: 'olympics',
    data: {
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'ON',
    value: 'on',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Onitsuka Tiger',
    value: 'onitsuka tiger',
    data: {
      year: '1949',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Onkler',
    value: 'onkler',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 7,
    display_name: 'Online Ceramics',
    value: 'online ceramics',
    data: {
      year: '2016',
      location: 'Los Angeles, US',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Opening Ceremony',
    value: 'opening ceremony',
    data: {
      year: '2002',
      location: 'New York, US',
    },
  },
  {
    status: '',
    count: 1,
    display_name: "O'Reilly Inc",
    value: 'oreilly inc',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Original Penguin',
    value: 'original penguin',
    data: {
      year: '1955',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'OriginalFake',
    value: 'originalfake',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Osiris',
    value: 'osiris',
    data: {
      year: '1996',
      location: '',
    },
  },
  {
    status: '',
    count: 215,
    display_name: 'Other',
    value: 'other',
    data: {
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Ottolinger',
    value: 'ottolinger',
    data: {
      location: 'Berlin, DE',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 2,
    display_name: 'Our Legacy',
    value: 'our legacy',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 3,
    display_name: 'P2P',
    value: 'p2p',
    data: {
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Paco Rabanne',
    value: 'paco rabanne',
    data: {
      location: 'Paris, FR',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Padberg and Sons',
    value: 'padberg and sons',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 23,
    display_name: 'Palace',
    value: 'palace',
    data: {
      year: '2009',
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Palladium',
    value: 'palladium',
    data: {
      location: '',
    },
  },
  {
    status: '',
    count: 14,
    display_name: 'Palm Angels',
    value: 'palm angels',
    data: {
      year: '2014',
      location: 'Milan, IT',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Paola Vilas',
    value: 'paola vilas',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'PARADIS3',
    value: 'paradis3',
    data: {
      location: '',
    },
  },
  {
    status: '',
    count: 3,
    display_name: 'Paris Saint-Germain',
    value: 'paris saint germain',
    data: {
      location: 'Paris, FR',
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Parra',
    value: 'parra',
    data: {
      year: '2002',
      location: 'Amsterdam, NL',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Paul Smith',
    value: 'paul smith',
    data: {
      year: '1970',
      location: 'London, UK',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Peter Do',
    value: 'peter do',
    data: {
      year: '2018',
      location: 'New York, US',
    },
  },
  {
    status: '',
    count: 60,
    display_name: 'PF Flyers',
    value: 'pf flyers',
    data: {
      year: '1937',
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Phillip Lim',
    value: 'phillip lim',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Piaget',
    value: 'piaget',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Pierre Hardy',
    value: 'pierre hardy',
    data: {
      year: '1999',
      location: 'Paris, FR',
    },
  },
  {
    status: '',
    count: 68,
    display_name: 'Pleasures',
    value: 'pleasures',
    data: {
      year: '2005',
      location: 'Los Angeles, US',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Pleats Please Issey Miyake',
    value: 'pleats please issey miyake',
    data: {
      year: '1993',
      location: 'Tokyo, JP',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Plona',
    value: 'plona',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 21,
    display_name: 'Pointer',
    value: 'pointer',
    data: {
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Polo',
    value: 'polo',
    data: {
      year: '1967',
      location: 'New York, US',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Polo by Ralph Lauren',
    value: 'polo by ralph lauren',
    data: {
      year: '1967',
      location: 'New York, US',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Polo Ralph Lauren',
    value: 'polo ralph lauren',
    data: {
      location: 'NYC, US',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 23,
    display_name: 'Pony',
    value: 'pony',
    data: {
      year: '1972',
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Porsche Design',
    value: 'porsche design',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Posters',
    value: 'posters',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 4,
    display_name: 'Prada',
    value: 'prada',
    data: {
      year: '1913',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Predovic-Runolfsdottir',
    value: 'predovic runolfsdottir',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 3,
    display_name: 'Price Test',
    value: 'price test',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 13,
    display_name: 'Pro Keds',
    value: 'pro keds',
    data: {
      year: '1949',
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Proenza',
    value: 'proenza',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Project Canvas',
    value: 'project canvas',
    data: {
      location: '',
    },
  },
  {
    status: '',
    count: 3,
    display_name: 'Psychworld',
    value: 'psychworld',
    data: {
      year: '2018',
      location: 'Los Angeles, US',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1029,
    display_name: 'Puma',
    value: 'puma',
    data: {
      year: '1948',
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Pyer Moss',
    value: 'pyer moss',
    data: {
      location: 'NYC, US',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Qubus',
    value: 'qubus',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Quigley, Feil and Halvorson',
    value: 'quigley feil and halvorson',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'R13',
    value: 'r13',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Racing',
    value: 'racing',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 117,
    display_name: 'Radii',
    value: 'radii',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 29,
    display_name: 'Raf Simons',
    value: 'raf simons',
    data: {
      year: '1995',
      location: 'Antwerp, BE',
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Randomevent',
    value: 'randomevent',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Ransom',
    value: 'ransom',
    data: {
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Rassvet',
    value: 'rassvet',
    data: {
      year: '2016',
      location: 'Moscow, RU',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Rawlings',
    value: 'rawlings',
    data: {
      year: '1887',
      location: '',
    },
  },
  {
    status: '',
    count: 3,
    display_name: 'READYMADE',
    value: 'readymade',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Real Bad Man',
    value: 'real bad man',
    data: {
      year: '2019',
      location: '',
    },
  },
  {
    status: '',
    count: 3,
    display_name: 'Red Wing',
    value: 'red wing',
    data: {
      year: '1905',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'RE/DONE',
    value: 'redone',
    data: {
      year: '2014',
      location: 'Los Angeles, US',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 882,
    display_name: 'Reebok',
    value: 'reebok',
    data: {
      year: '1958',
      location: 'Reebok, UK',
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 4,
    display_name: 'Reese Cooper',
    value: 'reese cooper',
    data: {
      year: '2016',
      location: 'Los Angeles, US',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Rempel-Hessel',
    value: 'rempel hessel',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Represent',
    value: 'represent',
    data: {
      year: '2012',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'RetroSuperFuture',
    value: 'retrosuperfuture',
    data: {
      year: '2007',
      location: 'IT',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Revenge X Storm',
    value: 'revenge x storm',
    data: {
      year: '2016',
      location: '',
    },
  },
  {
    status: '',
    count: 27,
    display_name: 'Rhude',
    value: 'rhude',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 11,
    display_name: 'Rick Ovens',
    value: 'rick ovens',
    data: {
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 4,
    display_name: 'Rick Owens DRKSHDW',
    value: 'rick owens drkshdw',
    data: {
      year: '1994',
      location: 'Paris, FR',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'RIPNDIP',
    value: 'ripndip',
    data: {
      year: '2009',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Rippin, Schneider and Nienow',
    value: 'rippin schneider and nienow',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'ROA',
    value: 'roa',
    data: {
      year: '2015',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Robel Inc',
    value: 'robel inc',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Robert Hessler',
    value: 'robert hessler',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Romaguera and Sons',
    value: 'romaguera and sons',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Royal Elastics',
    value: 'royal elastics',
    data: {
      year: '1996',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Rugged Exposure',
    value: 'rugged exposure',
    data: {
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Runolfsdottir Inc',
    value: 'runolfsdottir inc',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'S_S.IL',
    value: 's sil',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 5,
    display_name: 'Sacai',
    value: 'sacai',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Safsafu',
    value: 'safsafu',
    data: {
      location: 'Paris, FR',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 18,
    display_name: 'Saint Laurent',
    value: 'saint laurent',
    data: {
      year: '1961',
      location: 'Paris, FR',
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Saint Michael',
    value: 'saint michael',
    data: {
      location: 'Los Angeles, US',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Saintwoods',
    value: 'saintwoods',
    data: {
      year: '2011',
      location: 'Montreal, CA',
    },
  },
  {
    status: '',
    count: 3,
    display_name: 'Salomon',
    value: 'salomon',
    data: {
      year: '1947',
      location: 'Annecy, FR',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Salvanni',
    value: 'salvanni',
    data: {
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Salvetto',
    value: 'salvetto',
    data: {
      location: '',
    },
  },
  {
    status: '',
    count: 29,
    display_name: 'Samurai - Automated',
    value: 'samurai automated',
    data: {
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Sandal Boyz',
    value: 'sandal boyz',
    data: {
      year: '2016',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Sandro',
    value: 'sandro',
    data: {
      year: '1984',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Sandy Liang',
    value: 'sandy liang',
    data: {
      year: '2014',
      location: 'New York, US',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Saskia Diez',
    value: 'saskia diez',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Sasquatchfabrix.',
    value: 'sasquatchfabrix',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 314,
    display_name: 'Saucony',
    value: 'saucony',
    data: {
      year: '1898',
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Schmeler Group',
    value: 'schmeler group',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Schmitt-Wehner',
    value: 'schmitt wehner',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Seletti',
    value: 'seletti',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Sergio Rossi',
    value: 'sergio rossi',
    data: {
      year: '1951',
      location: '',
    },
  },
  {
    status: '',
    count: 2,
    display_name: 'Shino Takeda',
    value: 'shino takeda',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Shmack',
    value: 'shmack',
    data: {
      year: '2002',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Siberia Hills',
    value: 'siberia hills',
    data: {
      year: '2017',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Sies Marjan',
    value: 'sies marjan',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Simone Rocha',
    value: 'simone rocha',
    data: {
      year: '2010',
      location: 'London, UK',
    },
  },
  {
    status: '',
    count: 2,
    display_name: 'SIN Ceramics',
    value: 'sin ceramics',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Sinclair',
    value: 'sinclair',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Skechers',
    value: 'skechers',
    data: {
      year: '1992',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Skicks',
    value: 'skicks',
    data: {
      year: '2014',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'SLVRLAKE',
    value: 'slvrlake',
    data: {
      location: 'Los Angeles, US',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 4,
    display_name: 'Sneaker Conditions',
    value: 'sneaker conditions',
    data: {
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Sony',
    value: 'sony',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 2,
    display_name: 'Sorayama Space',
    value: 'sorayama space',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Sp5der',
    value: 'sp5der',
    data: {
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Sperry',
    value: 'sperry',
    data: {
      year: '1935',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Sports',
    value: 'sports',
    data: {
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Sports Illustrated',
    value: 'sports illustrated',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 7,
    display_name: 'Sporty & Rich',
    value: 'sporty rich',
    data: {
      year: '2014',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Starbury',
    value: 'starbury',
    data: {
      year: '2006',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Starter',
    value: 'starter',
    data: {
      year: '1971',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Starting Lineup',
    value: 'starting lineup',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Stella McCartney',
    value: 'stella mccartney',
    data: {
      year: '2001',
      location: 'London, UK',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Steve Madden',
    value: 'steve madden',
    data: {
      year: '1990',
      location: '',
    },
  },
  {
    status: '',
    count: 48,
    display_name: 'Stone Island',
    value: 'stone island',
    data: {
      year: '1982',
      location: 'Ravarino, IT',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Stone Island Shadow Project',
    value: 'stone island shadow project',
    data: {
      year: '2008',
      location: 'Ravarino, IT',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Straye',
    value: 'straye',
    data: {
      year: '1974',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Students',
    value: 'students',
    data: {
      location: 'Los Angeles, US',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 130,
    display_name: 'Stussy',
    value: 'stussy',
    data: {
      year: '1980',
      location: 'Laguna Beach, US',
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Suicoke',
    value: 'suicoke',
    data: {
      year: '2006',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'SUPER by RetroSuperFuture',
    value: 'super by retrosuperfuture',
    data: {
      year: '2007',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Superga',
    value: 'superga',
    data: {
      year: '1911',
      location: '',
    },
  },
  {
    status: '',
    count: 428,
    display_name: 'Supra',
    value: 'supra',
    data: {
      year: '2006',
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 234,
    display_name: 'Supreme',
    value: 'supreme',
    data: {
      year: '1994',
      location: 'New York, US',
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Swims',
    value: 'swims',
    data: {
      year: '2006',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'T by Alexander Wang',
    value: 't by alexander wang',
    data: {
      year: '2007',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Tacchini',
    value: 'tacchini',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 2,
    display_name: 'Takashi Murakami',
    value: 'takashi murakami',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Tas',
    value: 'tas',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'TCG Porter',
    value: 'tcg porter',
    data: {
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Technics',
    value: 'technics',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Telfar',
    value: 'telfar',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Teva',
    value: 'teva',
    data: {
      year: '1984',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'The Great Frog London',
    value: 'the great frog london',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 36,
    display_name: 'The Hundreds',
    value: 'the hundreds',
    data: {
      year: '2003',
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'The North Face',
    value: 'the north face',
    data: {
      year: '1968',
      location: 'San Francisco, US',
    },
  },
  {
    status: '',
    count: 3,
    display_name: 'The Skateroom',
    value: 'the skateroom',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Thiel Inc',
    value: 'thiel inc',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'This is a brand',
    value: 'this is a brand',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 7,
    display_name: 'thisisneverthat',
    value: 'thisisneverthat',
    data: {
      year: '2009',
      location: 'Seoul, SK',
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Thom Browne',
    value: 'thom browne',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Thursday',
    value: 'thursday',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Tibi',
    value: 'tibi',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Tier',
    value: 'tier',
    data: {
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Tim Teven Studio',
    value: 'tim teven studio',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 117,
    display_name: 'Timberland',
    value: 'timberland',
    data: {
      year: '1952',
      location: 'Boston, US',
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 1,
    display_name: "Tod's",
    value: 'tods',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Tom Sachs',
    value: 'tom sachs',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Tommy Hilfiger',
    value: 'tommy hilfiger',
    data: {
      year: '1985',
      location: 'New York, US',
    },
  },
  {
    status: '',
    count: 24,
    display_name: 'TOMS',
    value: 'toms',
    data: {
      year: '2006',
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Towne-Jast',
    value: 'towne jast',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Travis Scott',
    value: 'travis scott',
    data: {
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Tretorn',
    value: 'tretorn',
    data: {
      year: '1891',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Treutel, Hammes and Nolan',
    value: 'treutel hammes and nolan',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Tricot Comme des Garçons',
    value: 'tricot comme des garcons',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Trotters',
    value: 'trotters',
    data: {
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Trudon',
    value: 'trudon',
    data: {
      location: 'Paris, FR',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: "Turcotte, Dibbert and O'Kon",
    value: 'turcotte dibbert and okon',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'TV',
    value: 'tv',
    data: {
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Tyler, The Creator',
    value: 'tyler the creator',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Ugg',
    value: 'ugg',
    data: {
      year: '1978',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Umbro',
    value: 'umbro',
    data: {
      year: '1924',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: "Uncle Paulie's Deli",
    value: 'uncle paulies deli',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Uncommon Matters',
    value: 'uncommon matters',
    data: {
      location: 'Berlin, DE',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Undefeated',
    value: 'undefeated',
    data: {
      year: '2002',
      location: 'Los Angeles, US',
    },
  },
  {
    status: '',
    count: 145,
    display_name: 'Under Armour',
    value: 'under armour',
    data: {
      year: '1996',
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 14,
    display_name: 'Undercover',
    value: 'undercover',
    data: {
      year: '1993',
      location: 'Tokyo, JP',
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 2,
    display_name: 'Undrcrwn',
    value: 'undrcrwn',
    data: {
      year: '2005',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Uniqlo',
    value: 'uniqlo',
    data: {
      year: '1949',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'U.S. Polo Assn.',
    value: 'us polo assn',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Used Future',
    value: 'used future',
    data: {
      year: '2009',
      location: 'Seoul, SK',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Valentino',
    value: 'valentino',
    data: {
      year: '1960',
      location: 'Rome, IT',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Vaneli',
    value: 'vaneli',
    data: {
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Vaneli East',
    value: 'vaneli east',
    data: {
      location: '',
    },
  },
  {
    status: '',
    count: 2187,
    display_name: 'Vans',
    value: 'vans',
    data: {
      year: '1966',
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Veeko',
    value: 'veeko',
    data: {
      year: '1984',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Veja',
    value: 'veja',
    data: {
      year: '2004',
      location: 'Paris, FR',
    },
  },
  {
    status: '',
    count: 2,
    display_name: 'Versace',
    value: 'versace',
    data: {
      year: '1978',
      location: 'Milan, IT',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 5,
    display_name: 'Vetements',
    value: 'vetements',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Victor',
    value: 'victor',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Vintage',
    value: 'vintage',
    data: {
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Vision Street Wear',
    value: 'vision street wear',
    data: {
      year: '1976',
      location: '',
    },
  },
  {
    status: '',
    count: 48,
    display_name: 'Visvim',
    value: 'visvim',
    data: {
      year: '2001',
      location: 'Tokyo, JP',
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 4,
    display_name: 'Vivienne Westwood',
    value: 'vivienne westwood',
    data: {
      year: '1971',
      location: 'London, UK',
    },
  },
  {
    status: '',
    count: 3,
    display_name: 'Vlone',
    value: 'vlone',
    data: {
      year: '2013',
      location: 'New York, US',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Vogue',
    value: 'vogue',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Wacko Maria',
    value: 'wacko maria',
    data: {
      year: '2005',
      location: 'Tokyo, JP',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Wales Bonner',
    value: 'wales bonner',
    data: {
      year: '2014',
      location: 'London, UK',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Walter Inc',
    value: 'walter inc',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Warrior',
    value: 'warrior',
    data: {
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Watsica, Muller and Schamberger',
    value: 'watsica muller and schamberger',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'We11done',
    value: 'we11done',
    data: {
      year: '2014',
      location: 'Seoul, SK',
    },
  },
  {
    status: '',
    count: 12,
    display_name: 'WeSC',
    value: 'wesc',
    data: {
      year: '1999',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'White Mountaineering',
    value: 'white mountaineering',
    data: {
      year: '2006',
      location: 'Tokyo, JP',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Who Decides War',
    value: 'who decides war',
    data: {
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Wilfred',
    value: 'wilfred',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Wone',
    value: 'wone',
    data: {
      year: '2017',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Wrestle Boutique',
    value: 'wrestle boutique',
    data: {
      year: '2016',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'X-Men',
    value: 'x men',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 3,
    display_name: 'Y-3',
    value: 'y 3',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 17,
    display_name: 'Yamborghini',
    value: 'yamborghini',
    data: {
      mobile_display: true,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Yayoi Kusama',
    value: 'yayoi kusama',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 3,
    display_name: 'Yeezy',
    value: 'yeezy',
    data: {
      year: '2015',
      location: 'Calabasas, US',
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Yeezy Gap',
    value: 'yeezy gap',
    data: {
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Ylati',
    value: 'ylati',
    data: {
      year: '2012',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Yohji Yamamoto',
    value: 'yohji yamamoto',
    data: {
      year: '1972',
      location: 'Tokyo, JP',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Yohji Yamamoto Pour Homme',
    value: 'yohji yamamoto pour homme',
    data: {
      year: '1972',
      location: 'Tokyo, JP',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Youths In Balaclava',
    value: 'youths in balaclava',
    data: {
      year: '2015',
      location: '',
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'YZY',
    value: 'yzy',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Zemlak-Nikolaus',
    value: 'zemlak nikolaus',
    data: {
      mobile_display: false,
    },
  },
  {
    status: '',
    count: 1,
    display_name: 'Zengara',
    value: 'zengara',
    data: {
      location: '',
    },
  },
];

export const getAllBrandsFromConstructor = (searchJson = {}) => {
  const final = cloneDeep(searchJson);

  // Step 2: Process array and merge into final
  [].forEach((item) => {
    const name = item.display_name;
    const data: any = cloneDeep(item.data || {});

    // Compute web_display based on mobile_display

    data.web_display = true;

    if (data.location || data?.year) {
      //   if (final[name]) {
      //     // Brand already exists — only add web_display
      //     if (data.web_display === true) {
      //       final[name].web_display = true;
      //     }
      //   } else {
      // Brand doesn't exist — use array data
      final[name] = data;
      //   }
    }
  });

  const sortedlist = Object.keys(final).sort((a, b) => {
    // Sort by display_name
    return a.localeCompare(b);
  });

  const sortedObj = {};

  sortedlist.forEach((key) => {
    sortedObj[key] = final[key];
  });

  return sortedObj;
};
